module.exports = __webpack_public_path__ + "img/64.31ae5051.png";